function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m196 387h120v113.001h-120z",
  fill: "#c3dafd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 387h60v113.001h-60z",
  fill: "#a1b8d8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0h512v405h-512z",
  fill: "#e4f3ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 0h256v405h-256z",
  fill: "#c3dafd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301 276h-90v-60h-60v-90h60v-60h90v60h60v90h-60z",
  fill: "#ff5c5c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301 126v-60h-45v210h45v-60h60v-90z",
  fill: "#ff3838"
}), /*#__PURE__*/React.createElement("path", {
  d: "m166 482h180v30h-180z",
  fill: "#e4f3ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 482h90v30h-90z",
  fill: "#c3dafd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 310h512v30h-512z",
  fill: "#457899"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 310h256v30h-256z",
  fill: "#365c75"
}), /*#__PURE__*/React.createElement("path", {
  d: "m241 246h30v-60h60v-30h-60v-60h-30v60h-60v30h60z",
  fill: "#e4f3ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 156v-60h-15v150h15v-60h60v-30z",
  fill: "#c3dafd"
}));

var SvgHospital = function SvgHospital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHospital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hospital.88403205.svg";
export { ForwardRef as ReactComponent };